import { c } from 'react-compiler-runtime';
import { forwardRef, useRef, useContext } from 'react';
import { UnderlineNavContext } from './UnderlineNavContext.js';
import useIsomorphicLayoutEffect from '../utils/useIsomorphicLayoutEffect.js';
import { UnderlineItem } from '../internal/components/UnderlineTabbedInterface.js';
import classes from './UnderlineNavItem.module.css.js';
import { jsx } from 'react/jsx-runtime';

const UnderlineNavItem = /*#__PURE__*/forwardRef((t0, forwardedRef) => {
  const $ = c(31);
  let Icon;
  let ariaCurrent;
  let children;
  let counter;
  let onSelect;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      as: t1,
      href: t2,
      children,
      counter,
      onSelect,
      "aria-current": ariaCurrent,
      icon: Icon,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = Icon;
    $[2] = ariaCurrent;
    $[3] = children;
    $[4] = counter;
    $[5] = onSelect;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
  } else {
    Icon = $[1];
    ariaCurrent = $[2];
    children = $[3];
    counter = $[4];
    onSelect = $[5];
    props = $[6];
    t1 = $[7];
    t2 = $[8];
  }
  const Component = t1 === undefined ? "a" : t1;
  const href = t2 === undefined ? "#" : t2;
  const backupRef = useRef(null);
  const ref = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : backupRef;
  const {
    setChildrenWidth,
    setNoIconChildrenWidth,
    loadingCounters,
    iconsVisible
  } = useContext(UnderlineNavContext);
  let t3;
  let t4;
  if ($[9] !== ref || $[10] !== setChildrenWidth || $[11] !== setNoIconChildrenWidth) {
    t3 = () => {
      if (ref.current) {
        const domRect = ref.current.getBoundingClientRect();
        const icon = Array.from(ref.current.children).find(_temp);
        const content = Array.from(ref.current.children).find(_temp2);
        const text = content.textContent;
        const iconWidthWithMargin = icon ? icon.getBoundingClientRect().width + Number(getComputedStyle(icon).marginRight.slice(0, -2)) + Number(getComputedStyle(icon).marginLeft.slice(0, -2)) : 0;
        setChildrenWidth({
          text,
          width: domRect.width
        });
        setNoIconChildrenWidth({
          text,
          width: domRect.width - iconWidthWithMargin
        });
      }
    };
    t4 = [ref, setChildrenWidth, setNoIconChildrenWidth];
    $[9] = ref;
    $[10] = setChildrenWidth;
    $[11] = setNoIconChildrenWidth;
    $[12] = t3;
    $[13] = t4;
  } else {
    t3 = $[12];
    t4 = $[13];
  }
  useIsomorphicLayoutEffect(t3, t4);
  let t5;
  if ($[14] !== onSelect) {
    t5 = event => {
      if ((event.key === " " || event.key === "Enter") && !event.defaultPrevented && typeof onSelect === "function") {
        onSelect(event);
      }
    };
    $[14] = onSelect;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const keyDownHandler = t5;
  let t6;
  if ($[16] !== onSelect) {
    t6 = event_0 => {
      if (!event_0.defaultPrevented && typeof onSelect === "function") {
        onSelect(event_0);
      }
    };
    $[16] = onSelect;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  const clickHandler = t6;
  let t7;
  if ($[18] !== Component || $[19] !== Icon || $[20] !== ariaCurrent || $[21] !== children || $[22] !== clickHandler || $[23] !== counter || $[24] !== href || $[25] !== iconsVisible || $[26] !== keyDownHandler || $[27] !== loadingCounters || $[28] !== props || $[29] !== ref) {
    t7 = /*#__PURE__*/jsx("li", {
      className: classes.UnderlineNavItem,
      children: /*#__PURE__*/jsx(UnderlineItem, {
        ref: ref,
        as: Component,
        href: href,
        "aria-current": ariaCurrent,
        onKeyDown: keyDownHandler,
        onClick: clickHandler,
        counter: counter,
        icon: Icon,
        loadingCounters: loadingCounters,
        iconsVisible: iconsVisible,
        ...props,
        children: children
      })
    });
    $[18] = Component;
    $[19] = Icon;
    $[20] = ariaCurrent;
    $[21] = children;
    $[22] = clickHandler;
    $[23] = counter;
    $[24] = href;
    $[25] = iconsVisible;
    $[26] = keyDownHandler;
    $[27] = loadingCounters;
    $[28] = props;
    $[29] = ref;
    $[30] = t7;
  } else {
    t7 = $[30];
  }
  return t7;
});
UnderlineNavItem.displayName = 'UnderlineNavItem';
function _temp(child) {
  return child.getAttribute("data-component") === "icon";
}
function _temp2(child_0) {
  return child_0.getAttribute("data-component") === "text";
}

export { UnderlineNavItem };
